<template>
  <div id="app">
    <!-- <v-header/> -->
    <router-view/>
    <!-- <v-fotter/> -->
  </div>
</template>

<script>
import VHeader from './components/header'
import VFotter from './components/fotter'

export default {
  name: 'App',
  components: {
      VHeader,
      VFotter
  },
  mounted(){
    var a = localStorage.getItem("userid");//用户id
    if(!a || a=='null'){
      		// this.$router.push('/')
    }else{}
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding-top: 1rem;
	background: url('./assets/img/mobBackground.jpg') repeat center;
  background-size: auto 100%;
  
  position: absolute;top:0;left:0;width:100%;
}
body {
  -webkit-touch-callout:none;
  -webkit-user-select:none;
  -khtml-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  background: #fff;
}
* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
body,html{
	box-sizing:border-box;
	margin:0;
  padding:0;
  color: #777;
}
input,textarea {
  -webkit-user-select: text;
}
input[type="text"]{
  display: inline-block;
  border-radius: 0.2rem;
  background:none;  
  outline:none;  
  border:0px;
  -webkit-appearance: none;/*去掉内阴影*/
  -moz-appearance:none;
  box-sizing: border-box;
  padding: 0;
}
input:focus { outline: none; } 
ul,li{
  list-style: none;
  margin:0;
  padding:0;
}
video::-internal-media-controls-download-button {
  display:none;
}
video::-webkit-media-controls-enclosure {
  overflow:hidden;
}
video::-webkit-media-controls-panel {
  width: calc(100% + 30px); 
}
dl,dt,dd{
  margin:0;
  padding:0;
}
i{
  font-style: normal;
}
textarea{
  outline:none;
  resize:none;
  display: inline-block;
  box-sizing: border-box;
  border-radius: 0.2rem;
  width: 100%;
  border: 1px solid #f7f7f7;
  padding: 0.4rem;
  height: auto;
  height: 10rem;
  font-family: "AzoLight",Arial, sans-serif;
}
a{
  text-decoration:none;
  out-line:none;
  color: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue